import React, { useState } from "react";
import { injectModels } from "../redux/injectModels";
import { toast } from "react-toastify";
import { useParams, Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { routes } from "../constants/routes";
import HeaderLogo from "../components/Logo/HeaderLogo";
import { globalConstant } from "../constants/globalConstant";
import { handleConsoleError } from "../utils/common-methods";

function ResetPassword(props) {
  const { token } = useParams();
  const navigate = useNavigate();

  const [successMessage, setSuccessMessage] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [npassword, setNPassword] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);

  const togglePassword = (e) => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  const toggleConfirmPassword = (e) => {
    setShowNewPassword((prevShowPassword) => !prevShowPassword);
  };

  const handlenpasswordChange = (e) => {
    // e.preventDefault();
    const val = e.target?.value;
    if (val?.trim() === "") {
      setError("New Password is required");
    } else if (!globalConstant.passwordRegex.test(npassword)) {
      setError(
        "New Password must contain at least one uppercase letter, one lowercase letter, one number, one symbol and minimum length is 8!.Allowed symbol are @$!%*?&-"
      );
    } else {
      setError("");
    }
    setNPassword(val?.trim());
  };

  const handleConfirmPasswordChange = (e) => {
    // e.preventDefault();
    const val = e.target.value;
    if (val.trim() === "") {
      setError("Confirm Password is required!");
    } else {
      setError("");
    }
    setConfirmPassword(val.trim());
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let valid = true;

    if (npassword.trim() === "") {
      setError("New Password is required!");
      valid = false;
      return;
    } else {
      if (!globalConstant.passwordRegex.test(npassword)) {
        setError(
          "New Password must contain at least one uppercase letter, one lowercase letter, one number, one symbol and minimum length is 8!"
        );
        return;
      }
      setError("");
    }

    if (confirmPassword?.trim() === "") {
      setError("Confirm Password is required!");
      valid = false;
      return;
    } else {
      setError("");
    }

    if (npassword.length < 8) {
      setError("New Password must be at least 8 characters long!");
      valid = false;
      return;
    }

    // Check if new password and confirm password match
    if (npassword !== confirmPassword) {
      setError("New Password and Confirm Password did not match!");
      valid = false;
      return;
    }

    if (!valid) {
      toast.error("Please fill all the details!");
      return;
    } else {
      setError("");
      const data = {
        password: confirmPassword,
        confirmPassword: confirmPassword,
        token: token,
      };

      try {
        const res = await props.admin.resetPassword(data);
        props.application.setLoading(true);
        if (res?.isSuccess === true) {
          props.application.setLoading(false);
          toast.success("Password changed successfully");
          setError("");
          navigate("/");
        } else {
          props.application.setLoading(false);
          setError("Reset Password link is invalid or has been expired");
          setSuccessMessage("");
          toast.error(
            res?.data || "Reset Password link is invalid or has been expired"
          );
        }
      } catch (error) {
        const message= handleConsoleError(error);
        toast.error(error?.message || message);
        props.application.setLoading(false);
      }
    }
  };

  return (
    <React.Fragment>
      <section className="loginswallow">
        <div
          className="form-container"
          id="form-container"
          style={{ margin: "100px auto" }}
        >
          <form id="login-form" className="p-3">
            <HeaderLogo></HeaderLogo>
            <h3>Reset Password</h3>
            <label htmlFor="username">New Password</label>
            <div className="password-container">
              <input
                type={showPassword ? "text" : "password"}
                placeholder="New Password"
                id="login-username"
                onChange={handlenpasswordChange}
                maxLength={80}
              />
              {showPassword ? (
                <i
                  className="fa-solid fa-eye"
                  id="login-eye"
                  onClick={togglePassword}
                ></i>
              ) : (
                <i
                  className="fa-solid fa-eye-slash"
                  id="login-eye"
                  onClick={togglePassword}
                ></i>
              )}
            </div>
            <label htmlFor="password">Confirm Password</label>
            <div className="password-container">
              <input
                type={showNewPassword ? "text" : "password"}
                placeholder="Confirm Password"
                id="login-password"
                maxLength={80}
                onChange={handleConfirmPasswordChange}
              />
              {showNewPassword ? (
                <i
                  className="fa-solid fa-eye"
                  id="login-eye"
                  onClick={toggleConfirmPassword}
                ></i>
              ) : (
                <i
                  className="fa-solid fa-eye-slash"
                  id="login-eye"
                  onClick={toggleConfirmPassword}
                ></i>
              )}
            </div>

            {successMessage && (
              <span className="alert alert-success">{successMessage}</span>
            )}
            {error && <p className="text-danger">{error}</p>}
            <button type="submit" onClick={handleSubmit}>
              Change Password
            </button>

            <p className="signup-text">
              Don't have an account? <Link to={routes.DEFAULT}>Sign Up</Link>
            </p>
          </form>
        </div>
      </section>
    </React.Fragment>
  );
}
export default injectModels(["admin", "application"])(ResetPassword);
